import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import TagsOverviewDialog from "./TagsOverviewDialog";
import TagsEditDialog from "./TagsEditDialog";
import API from "../../../utils/axios";
import { setTags } from "../../../store/actions/account";
import { compare } from "../../../utils/helpers";

function TagsDialog({
  saveDisabled,
  setSaveDisabled,
  handleClose,
  open,
  tagsLoaded,
  tags,
  setTags,
  ...props
}) {
  const sortTagsByName = tags => {
    return [...tags].sort((tag1, tag2) => {
      return compare(tag1.name, tag2.name);
    });
  };

  useEffect(() => {
    if (open) {
      API.get("/v1/tags")
        .then(res => {
          console.log(res.data);
          setTags(res.data);
        })
        .catch(console.log);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const [currentAction, setCurrentAction] = useState("overview");
  const [currentTag, setCurrentTag] = useState(null);
  const [backFromEditAction, setBackFromEditAction] = useState(false);

  return (
    <>
      {currentAction === "edit" ? (
        <TagsEditDialog
          {...props}
          open={open}
          setCurrentAction={setCurrentAction}
          currentTag={currentTag}
          saveDisabled={saveDisabled}
          setTags={setTags}
          tags={tags}
          setSaveDisabled={setSaveDisabled}
          setBackFromEditAction={setBackFromEditAction}
        />
      ) : (
        <TagsOverviewDialog
          {...props}
          open={open}
          tags={sortTagsByName(tags)}
          setTags={setTags}
          handleClose={handleClose}
          setCurrentAction={setCurrentAction}
          setCurrentTag={setCurrentTag}
          setBackFromEditAction={setBackFromEditAction}
          backFromEditAction={backFromEditAction}
          tagsLoaded={tagsLoaded}
        />
      )}
    </>
  );
}

const mapStateToProps = state => ({
  tags: state.account.tags,
  tagsLoaded: state.loading.tagsListLoaded
});

export default connect(mapStateToProps, { setTags })(TagsDialog);
